module.exports = __webpack_public_path__ + "img/jameson-form-bg-right.332353ec.png";